import { render, staticRenderFns } from "./select-os.vue?vue&type=template&id=38cd142d"
import script from "./select-os.vue?vue&type=script&lang=js"
export * from "./select-os.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports